import { render } from "./Suggestion.vue?vue&type=template&id=0a50986f&scoped=true&ts=true"
import script from "./Suggestion.vue?vue&type=script&lang=ts"
export * from "./Suggestion.vue?vue&type=script&lang=ts"

import "./Suggestion.vue?vue&type=style&index=0&id=0a50986f&lang=scss&scoped=true"

import exportComponent from "/var/www/tenanthub.au/runners/admin/root/tenanthub-admin/tenanthub-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a50986f"]])

export default __exports__